import { Link } from "react-router-dom";
import { Linkedin, MessageCircle, Phone, Mail } from "lucide-react";
import { PHONE, WHATSAPP_URL, LINKEDIN_URL, EMAIL, LOGO_APRATIM } from "../../data/content";

export function SiteFooter() {
  return (
    <footer className="bg-[#0b170f] text-[#f7f5f0]/60 border-t border-[#12281a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-3 gap-10 text-xs">
        <div>
          <div className="flex items-center gap-4 mb-4">
            <img src="/assets/jb-mark.png" alt="Jaybhaye Realty logo" className="h-14 w-auto object-contain" loading="lazy" />
            <img src={LOGO_APRATIM} alt="Apratim Group logo" className="h-14 w-auto max-w-[120px] object-contain bg-[#f7f5f0] p-1" loading="lazy" />
          </div>
          <span className="font-monument text-sm font-semibold text-[#f7f5f0] block">
            Jaybhaye Realty Pvt. Ltd.
          </span>
          <span className="block mt-1">Backed by the 15+ year legacy of Apratim Group / Apratim Builders</span>
          <span className="block mt-3 text-[#b38b47] uppercase tracking-widest">Growing with Integrity</span>
        </div>

        <div>
          <span className="text-[#b38b47] uppercase tracking-widest font-semibold block mb-4">Explore</span>
          <div className="grid grid-cols-2 gap-2 uppercase tracking-widest text-[11px]">
            <Link to="/" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-home">Home</Link>
            <Link to="/about" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-about">About</Link>
            <Link to="/projects" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-projects">Projects</Link>
            <Link to="/legacy" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-legacy">Legacy</Link>
            <Link to="/insights" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-insights">Insights</Link>
            <Link to="/contact" className="hover:text-[#b38b47] transition-colors py-1" data-testid="footer-link-contact">Contact</Link>
          </div>
        </div>

        <div>
          <span className="text-[#b38b47] uppercase tracking-widest font-semibold block mb-4">Connect</span>
          <div className="flex flex-col gap-3">
            <a href={`tel:+91${PHONE}`} className="flex items-center gap-2 hover:text-[#b38b47] transition-colors" data-testid="footer-phone-link">
              <Phone size={14} /> +91 {PHONE}
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#b38b47] transition-colors" data-testid="footer-whatsapp-link">
              <MessageCircle size={14} /> WhatsApp
            </a>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-[#b38b47] transition-colors" data-testid="footer-email-link">
              <Mail size={14} /> {EMAIL}
            </a>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#b38b47] transition-colors" data-testid="footer-linkedin-link">
              <Linkedin size={14} /> LinkedIn
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#f7f5f0]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-[#f7f5f0]/40">
          <span>© {new Date().getFullYear()} Jaybhaye Realty Pvt. Ltd. · Chhatrapati Sambhaji Nagar · Pune</span>
          <span>Legacy of Apratim Group / Apratim Builders</span>
        </div>
      </div>
    </footer>
  );
}
